import { render, staticRenderFns } from "./EnquiryFollowUpsList.vue?vue&type=template&id=3040790a&scoped=true&"
import script from "./EnquiryFollowUpsList.vue?vue&type=script&lang=js&"
export * from "./EnquiryFollowUpsList.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryFollowUpsList.vue?vue&type=style&index=0&id=3040790a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3040790a",
  null
  
)

export default component.exports